// extracted by mini-css-extract-plugin
export var controlArrows = "ControlArrows-module--controlArrows--2649b";
export var controlArrows_button = "ControlArrows-module--controlArrows_button--0a2a7";